var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonCarrier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -2110.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Carrier",
    transform: "translate(1206.000000, 2110.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.859,6.00766677 C6.579,6.00766677 7.97,7.4126855 7.97,9.14670862 L7.97,9.14670862 L7.97,16.4038054 L7.11,16.4038054 L7.11,24.9489193 L8,24.9489193 L8,21.922879 L12,21.922879 L12,18.8978386 L16,18.8978386 L16,15.8717983 L20,15.8717983 L20,12.8457579 L24,12.8457579 L24,9.82071761 L28,9.82071761 L28,6.80167736 C30.214,6.83767784 32,8.65270204 32,10.8947319 L32,10.8947319 L32,31 L0,31 L0,24.9489193 L3.163,24.9489193 L3.163,19.0588408 L0,19.0588408 L0,14.6327818 L1.746,14.6327818 L1.746,9.14670862 C1.746,7.4126855 3.14,6.00766677 4.859,6.00766677 Z M6.1885,1 C7.2145,1 8.0445,1.83601115 8.0445,2.86902492 C8.0445,3.90303871 7.2145,4.74204989 6.1885,4.74204989 C5.1655,4.74204989 4.3345,3.90303871 4.3345,2.86902492 C4.3345,1.83601115 5.1655,1 6.1885,1 Z",
    id: 199
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonCarrier);
export default __webpack_public_path__ + "static/media/common-carrier.627b1563.svg";
export { ForwardRef as ReactComponent };